const key = "https://my-lovodi-server.adaptable.app";
// const key = "http://localhost:5000";
export default key;